window.app.factory("setupTopLevelNotif", [
  "$rootScope",
  "apiCall",
  function($rootScope, apiCall) {
    return function setupTopLevelNotif() {
      if ($rootScope.publicMode) return;
      $rootScope.initReady.then(function() {
        apiCall({ endpoint: "news/$/@/levelOne" }).then(
          article => {
            $rootScope.levelOneNotif = article;
          },
          error => {
            $rootScope.levelOneNotif = null;
            console.error("Error fetching level one notification: ", error);
          }
        );
      });

      $rootScope.showTopNotif = () =>
        $rootScope.levelOneNotif &&
        $rootScope.levelOneNotif.id !=
          appStorage.getItem("lastReadLevelOneNotif");

      $rootScope.topNotifClick = () => {
        appStorage.setItem(
          "lastReadLevelOneNotif",
          $rootScope.levelOneNotif.id
        );
      };
    };
  }
]);



// WEBPACK FOOTER //
// ./src/helpers/setupTopLevelNotif.js